<app-competition-import-values-list
  [competitionWzObject]="competitionWzObject"
  [dialogRef]="dialogRef"
></app-competition-import-values-list>
